import { gql } from '@apollo/client';

// Saves this browser's Firebase Installation ID (FID) for the logged-in user. Pass oldFid (this browser's previous
// FID) only when there is one; when the variable is left out, the argument isn't sent.
export const UPDATE_USERS_FID = gql`
  mutation updateUsersFid($fid: String!, $oldFid: String) {
    updateUsersFid(fid: $fid, oldFid: $oldFid)
  }
`;

// Removes this browser's FID from the logged-in user (on logout), so the backend stops sending to it
export const REMOVE_USERS_FID = gql`
  mutation removeUsersFid($fid: String!) {
    removeUsersFid(fid: $fid)
  }
`;

// Saves whether the user allowed notifications in this browser
export const UPDATE_USER_ALLOW_NOTIFICATIONS = gql`
  mutation updateUserAllowNotifications($uId: UUID!, $allowNotifications: Boolean!) {
    updateUserByUId(input: { uId: $uId, userPatch: { uAllowNotifications: $allowNotifications } }) {
      clientMutationId
    }
  }
`;
